import * as React from 'react'
import './style.less'
import {Pictograms} from 'telstra-ui/components/svg/Pictograms'

const NoMarkerDataInt = () => {
  return (
    <div className="tc-np-map-marker-no-data-container">
      <div className="tc-np-inner-container">
        <div className="tc-np-description-container">
          <Pictograms name="picto-empty" className="picto-empty" />
          <summary className="heading16 summary">No data available</summary>
          <div className="description">
            You don't have any services that can be viewed or managed in Telstra Connect.
          </div>
          <div className="description">
            Once you do, you can access them from here.
          </div>
        </div>
      </div>
    </div>
  )
}

export {NoMarkerDataInt}
